import React, { Fragment } from "react";
import Loader from "../Loader/Loader";
import PropTypes from "prop-types";

// function LoaderButton({ children, spinner, isLoading }) {
//   if (isLoading && spinner) return <Loader spinner={spinner} />;
//   return <Fragment>{children}</Fragment>;
// }


function LoaderButton({ children, spinner = false, isLoading = false }) {
  return (
    <Fragment>
      {isLoading && spinner ? <Loader spinner={spinner} /> : children}
    </Fragment>
  );
}

// LoaderButton.propTypes = {
//   spinner: PropTypes.bool,
//   children: PropTypes.node,
//   isLoading: PropTypes.bool,
// };

export default LoaderButton;
// function LoaderButton({ children, spinner, isLoading }) {
//   if (isLoading && spinner) return <Loader spinner={spinner} />;
//   return <Fragment>{children}</Fragment>;
// }

// LoaderButton.propTypes = {
//   spinner: PropTypes.bool,
//   children: PropTypes.node,
//   isLoading: PropTypes.bool,
// };

// export default LoaderButton;
